export default function asArray(enumerableOrArray) {
    return [...enumerableOrArray];
}
